module.exports = __webpack_public_path__ + "static/img/hand1.7cf2e6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hand1.png
// module id = Ydmo
// module chunks = 208